import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RichTextEditorModule } from './richtexteditor.module';
import { Toolbar, Link, Image, Count, QuickToolbar, HtmlEditor, MarkdownEditor, Table } from '@syncfusion/ej2-richtexteditor';
export var ToolbarService = { provide: 'RichTextEditorToolbar', useValue: Toolbar };
export var LinkService = { provide: 'RichTextEditorLink', useValue: Link };
export var ImageService = { provide: 'RichTextEditorImage', useValue: Image };
export var CountService = { provide: 'RichTextEditorCount', useValue: Count };
export var QuickToolbarService = { provide: 'RichTextEditorQuickToolbar', useValue: QuickToolbar };
export var HtmlEditorService = { provide: 'RichTextEditorHtmlEditor', useValue: HtmlEditor };
export var MarkdownEditorService = { provide: 'RichTextEditorMarkdownEditor', useValue: MarkdownEditor };
export var TableService = { provide: 'RichTextEditorTable', useValue: Table };
/**
 * NgModule definition for the RichTextEditor component with providers.
 */
var RichTextEditorAllModule = /** @class */ (function () {
    function RichTextEditorAllModule() {
    }
    RichTextEditorAllModule.decorators = [
        { type: NgModule, args: [{
                    imports: [CommonModule, RichTextEditorModule],
                    exports: [
                        RichTextEditorModule
                    ],
                    providers: [
                        ToolbarService,
                        LinkService,
                        ImageService,
                        CountService,
                        QuickToolbarService,
                        HtmlEditorService,
                        MarkdownEditorService,
                        TableService
                    ]
                },] },
    ];
    /** @nocollapse */
    RichTextEditorAllModule.ctorParameters = function () { return []; };
    return RichTextEditorAllModule;
}());
export { RichTextEditorAllModule };
//# sourceMappingURL=richtexteditor-all.module.js.map